import { Injectable, OnDestroy } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { SESSION_STORAGE } from '@phdsoft/common';
import { DocumentsFormComponent } from '../../documents/documents-form/documents-form.component';
import { DocumentsSearchComponent } from '../../documents/documents-search/documents-search.component';
import { PdfViewerComponent } from '../../documents/pdf-viewer/pdf-viewer.component';
import { TemplateService } from '../../template.service';
import { environment } from 'src/environments/environment';
import { AdminDocumentsService } from '@app/shared/services/admin-documents.service';
import { LanguagePreferenceService } from '@app/shared/services/language-preference.service';

@Injectable() // Do NOT provide at root. Does not make sense globally
export class MenuDocumentsConfig implements OnDestroy {

  constructor(
    public dialog: MatDialog,
    private templateService: TemplateService,
    private adminDocumentsService: AdminDocumentsService,
    private languageService: LanguagePreferenceService,
  ) { }

  ngOnDestroy(): void {
    sessionStorage.setItem(SESSION_STORAGE.DOCUMENTS_ACTIVE, '0');
  }

  documentAdd = () => {
    this.templateService.toggleDocumentsForm(true);
  }

  documentSearch = () => {
    this.templateService.toggleDocumentsSearch(true);
  }

  softwareManual = () => {
    const currentLanguage = this.languageService.getCurrentLanguage();

    const softwareManualUrl = this.adminDocumentsService.getSoftwareManualUrl(currentLanguage);

    const title = 'Software Manual';

    this.dialog.open(PdfViewerComponent, {
      data: {
        pdfUrl: softwareManualUrl,
        title: title
      },
      hasBackdrop: true,
      panelClass: 'pdf-viewer-dialog',
      width: '90vw',
      height: '90vh',
      maxWidth: 'none',
      maxHeight: 'none'
    });
  }
}
